/// <reference path="../../../common/common/common.ts" />
/// <reference path="../../../../teva/selectbox/selectbox.ts" />

namespace OfficeGuy.Inputs {
    export class CurrencyPicker {
        static InitEditors(Container = null) {
            Teva.SelectBox.Enable($("input.currencypicker", Container), {
                QueryMethod: function (Query, QueryByID, PageIndex, Callback) {
                    Common.AjaxRequest({
                        Method: 'GET',
                        URL: "/currencypicker/",
                        SuccessMethod: function (Response) {
                            var data = {
                                results: Teva.SelectBox.FilterResults(Response, Query, QueryByID),
                                more: false
                            };
                            Callback(data, Query);
                        },
                        ShowLoading: false
                    });
                },
                AllowManualValues: true,
                SelectFirstOnClose: true
            });
        }
    }
}

$(document).on("Teva.InitEditors", function (Event, Container) {
    OfficeGuy.Inputs.CurrencyPicker.InitEditors(Container);
});